import { createSlice } from '@reduxjs/toolkit'
export const tripRoutesSlice = createSlice({
  name: 'tripRoutes',
  initialState: {
    isRefreshRouteGridData: false
  },
  reducers: {
    refreshRouteGridData: (state, action) => {
      state.isRefreshRouteGridData = action.payload;
      return state;
    },
  }
})
export const { refreshRouteGridData } = tripRoutesSlice.actions
export default tripRoutesSlice.reducer 
